/**
 * The reusable UI components that are used across the application.
 * @returns Common UI components.
 */
export const CommonUIComponents = () => {
    return <></>;
};
